export enum PDxTransmissionMethod {
    Email = 1,
    SFTP,
    EFax,
}